import { render, staticRenderFns } from "./WavesBlockWithImage.vue?vue&type=template&id=e1357b2e"
import script from "./WavesBlockWithImage.vue?vue&type=script&lang=js"
export * from "./WavesBlockWithImage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports